(function () {

  const stickyHeader = document.querySelector('[data-ws-sticky-header]');

  if (stickyHeader && stickyHeader.dataset.wsStickyHeaderReady !== 'true') {

    stickyHeader.dataset.wsStickyHeaderReady = 'true';

    let frame = 0;

    const updateStickyHeaderHeight = () => {

      window.cancelAnimationFrame(frame);

      frame = window.requestAnimationFrame(() => {

        const height = Math.ceil(stickyHeader.getBoundingClientRect().height);

        document.documentElement.style.setProperty('--sticky-header-height', `${height}px`);

      });

    };



    const observer = new ResizeObserver(updateStickyHeaderHeight);

    observer.observe(stickyHeader);

    window.addEventListener('resize', updateStickyHeaderHeight, { passive: true });

    updateStickyHeaderHeight();

  }

  document.querySelectorAll('[data-ws-header]').forEach((header) => {

    if (header.dataset.wsNavigationReady === 'true') return;

    header.dataset.wsNavigationReady = 'true';



    const menuToggle = header.querySelector('[data-ws-mobile-menu-toggle]');

    const menuPanel = header.querySelector('[data-ws-mobile-menu]');

    const menuClose = header.querySelector('[data-ws-mobile-menu-close]');

    const menuBackdrop = header.querySelector('[data-ws-mobile-menu-backdrop]');

    const desktopDropdowns = Array.from(header.querySelectorAll('[data-ws-nav-dropdown]'));

    const dropdownCloseTimers = new WeakMap();



    function setMobileSubnav(toggle, open) {

      const panelId = toggle.getAttribute('aria-controls');

      const panel = panelId ? document.getElementById(panelId) : null;

      if (!panel) return;

      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      panel.toggleAttribute('hidden', !open);

    }



    function closeMobileSubnavs() {

      header.querySelectorAll('[data-ws-mobile-subnav-toggle]').forEach((toggle) => {

        setMobileSubnav(toggle, false);

      });

    }



    const inertSiblings = new Map();
    const menuFocusable = () => [...menuPanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(node => node.getClientRects().length && !node.closest('[inert]'));
    function isolateMenu(open) {
      if (!open) {
        inertSiblings.forEach((value,node) => { node.inert = value; });
        inertSiblings.clear();
        return;
      }
      for (let node = menuPanel; node && node !== document.body; node = node.parentElement) {
        for (const sibling of node.parentElement.children) {
          if (sibling === node || sibling === menuBackdrop || ['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) continue;
          if (!inertSiblings.has(sibling)) inertSiblings.set(sibling, sibling.inert);
          sibling.inert = true;
        }
      }
    }
    document.addEventListener('keydown', event => {
      if (menuPanel?.hidden || event.key !== 'Tab') return;
      const items = menuFocusable(), first = items[0], last = items.at(-1);
      if (!first) { event.preventDefault(); menuPanel.focus(); return; }
      if (!menuPanel.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {
        event.preventDefault(); (event.shiftKey ? last : first).focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    const desktopMenu = matchMedia('(min-width: 990px)');
    desktopMenu.addEventListener('change', event => {
      if (event.matches && menuPanel && !menuPanel.hidden) setMenu(false, false);
    });
    function setMenu(open, restoreFocus = true) {

      if (!menuToggle || !menuPanel || !menuClose || !menuBackdrop) return;

      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      menuPanel.toggleAttribute('hidden', !open);

      menuBackdrop.toggleAttribute('hidden', !open);

      menuPanel.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.documentElement.classList.toggle('mobile-nav-open', open);
      isolateMenu(open);

      if (open) {

        const firstTarget = menuPanel.querySelector('a, button, input');

        firstTarget?.focus();

      } else {

        closeMobileSubnavs();

        if (restoreFocus) menuToggle.focus();

      }

    }



    function setDesktopDropdown(dropdown, open, restoreFocus = false) {

      const toggle = dropdown.querySelector('[data-ws-nav-dropdown-toggle]');

      const panel = dropdown.querySelector('[data-ws-nav-dropdown-panel]');

      if (!toggle || !panel) return;

      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      panel.toggleAttribute('hidden', !open);

      dropdown.classList.toggle('is-open', open);

      if (!open && restoreFocus) toggle.focus();

    }



    function cancelDesktopDropdownClose(dropdown) {

      const timer = dropdownCloseTimers.get(dropdown);

      if (timer) window.clearTimeout(timer);

      dropdownCloseTimers.delete(dropdown);

    }



    function scheduleDesktopDropdownClose(dropdown) {

      cancelDesktopDropdownClose(dropdown);

      const timer = window.setTimeout(() => {

        dropdownCloseTimers.delete(dropdown);

        if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) {

          setDesktopDropdown(dropdown, false);

        }

      }, 180);

      dropdownCloseTimers.set(dropdown, timer);

    }



    function closeDesktopDropdowns(exception = null) {

      desktopDropdowns.forEach((dropdown) => {

        if (dropdown !== exception) {

          cancelDesktopDropdownClose(dropdown);

          setDesktopDropdown(dropdown, false);

        }

      });

    }



    menuToggle?.addEventListener('click', () => {

      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');

    });



    menuClose?.addEventListener('click', () => setMenu(false));

    menuBackdrop?.addEventListener('click', () => setMenu(false));

    menuPanel?.addEventListener('click', (event) => {

      if (event.target.closest('a[href]')) setMenu(false, false);

    });



    header.querySelectorAll('[data-ws-mobile-subnav-toggle]').forEach((toggle) => {

      toggle.addEventListener('click', () => {

        setMobileSubnav(toggle, toggle.getAttribute('aria-expanded') !== 'true');

      });

    });



    desktopDropdowns.forEach((dropdown) => {

      const toggle = dropdown.querySelector('[data-ws-nav-dropdown-toggle]');

      toggle?.addEventListener('click', (event) => {

        event.stopPropagation();

        const open = toggle.getAttribute('aria-expanded') !== 'true';

        closeDesktopDropdowns(dropdown);

        setDesktopDropdown(dropdown, open);

      });



      dropdown.addEventListener('pointerenter', () => {

        if (window.matchMedia('(hover: hover)').matches) {

          cancelDesktopDropdownClose(dropdown);

          closeDesktopDropdowns(dropdown);

          setDesktopDropdown(dropdown, true);

        }

      });



      dropdown.addEventListener('pointerleave', () => {

        if (window.matchMedia('(hover: hover)').matches && !dropdown.contains(document.activeElement)) {

          scheduleDesktopDropdownClose(dropdown);

        }

      });



      dropdown.addEventListener('focusin', (event) => {
        if (event.target === toggle) return; // Escape restores focus without reopening the panel.

        cancelDesktopDropdownClose(dropdown);

        closeDesktopDropdowns(dropdown);

        setDesktopDropdown(dropdown, true);

      });



      dropdown.addEventListener('focusout', (event) => {

        if (!dropdown.contains(event.relatedTarget)) scheduleDesktopDropdownClose(dropdown);

      });

    });



    document.addEventListener('pointerdown', (event) => {

      if (!header.contains(event.target)) closeDesktopDropdowns();

    });



    document.addEventListener('keydown', (event) => {

      if (event.key !== 'Escape') return;

      const openDropdown = desktopDropdowns.find((dropdown) => dropdown.classList.contains('is-open'));

      if (openDropdown) {

        setDesktopDropdown(openDropdown, false, true);

        return;

      }

      if (menuToggle?.getAttribute('aria-expanded') === 'true') setMenu(false);

    });

  });



  const announcement = document.querySelector('[data-ws-announcement]');

  const announcementDismiss = announcement?.querySelector('[data-ws-announcement-dismiss]');



  if (announcement && announcementDismiss) {

    const storageKey = `ws-announcement-${announcement.dataset.announcementKey}`;



    try {

      if (window.sessionStorage.getItem(storageKey) === 'dismissed') {

        announcement.remove();

      }

    } catch (error) {

      void error;

    }



    announcementDismiss.addEventListener('click', () => {

      try {

        window.sessionStorage.setItem(storageKey, 'dismissed');

      } catch (error) {

        void error;

      }

      announcement.remove();

    });

  }



  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {

    const main = gallery.querySelector('[data-gallery-main]');

    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));

    const activateThumb = (thumb, focus = false) => {

      if (!thumb) return;

      if (focus) thumb.focus();

        if (main && thumb.dataset.src) {

          main.src = thumb.dataset.src;

          if (thumb.dataset.alt) main.alt = thumb.dataset.alt;

        }

      thumbs.forEach((item) => {

          const active = item === thumb;

          item.classList.toggle('is-active', active);

          item.toggleAttribute('aria-current', active);

        });

    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activateThumb(thumb)));

    gallery.addEventListener('keydown', (event) => {

      const current = event.target.closest('[data-gallery-thumb]');

      if (!current || !thumbs.includes(current)) return;

      const index = thumbs.indexOf(current);

      let nextIndex = null;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % thumbs.length;

      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + thumbs.length) % thumbs.length;

      if (event.key === 'Home') nextIndex = 0;

      if (event.key === 'End') nextIndex = thumbs.length - 1;

      if (nextIndex === null) return;

      event.preventDefault();

      activateThumb(thumbs[nextIndex], true);

    });

    if (main) {

      main.addEventListener('load', () => main.setAttribute('aria-busy', 'false'));

      main.setAttribute('aria-busy', 'false');

    }

  });



  const parseJsonNode = (node) => {

    if (!node) return null;

    try {

      return JSON.parse(node.textContent);

    } catch (error) {

      void error;

      return null;

    }

  };



  const initializeProductForm = (form) => {

    if (form.dataset.purchaseStateReady === 'true') return;



    const purchaseState = parseJsonNode(form.querySelector('[data-product-purchase-state]'));

    if (!purchaseState) return;



    form.dataset.purchaseStateReady = 'true';

    const preorderState = parseJsonNode(form.querySelector('[data-preorder-product-state]'));

    const info = form.closest('[data-product-info]') || form.parentElement;

    const commerceState = String(form.dataset.commerceState || 'sell_now');

    const panel = form.querySelector('[data-preorder-panel]');

    const submit = form.querySelector('[data-product-submit]');

    const purchaseControls = form.querySelector('[data-product-purchase-controls]');

    const isGiftCard = Boolean(info?.closest('.product-page--gift-card'));

    let giftCardVariantInteracted = false;

    const unavailable = form.querySelector('[data-product-unavailable]');
    const availabilityNotice = info?.querySelector('[data-availability-notice]');
    const availabilityToggle = availabilityNotice?.querySelector('[data-availability-toggle]');
    const availabilityPanel = availabilityNotice?.querySelector('[data-availability-panel]');
    let previousAvailabilityVariantId = null;

    const setAvailabilityPanel = (open) => {
      if (!availabilityToggle || !availabilityPanel) return;
      availabilityToggle.setAttribute('aria-expanded', String(open));
      availabilityToggle.hidden = open;
      availabilityPanel.hidden = !open;
      availabilityNotice.dataset.availabilityOpen = String(open);
    };

    if (availabilityNotice && availabilityToggle && availabilityPanel && availabilityNotice.dataset.availabilityNoticeReady !== 'true') {
      availabilityNotice.dataset.availabilityNoticeReady = 'true';
      setAvailabilityPanel(availabilityToggle.getAttribute('aria-expanded') === 'true');
      availabilityToggle.addEventListener('click', () => {
        setAvailabilityPanel(availabilityToggle.getAttribute('aria-expanded') !== 'true');
      });
    }


    const selectedSellingPlan = () => {

      const controls = Array.from(info?.querySelectorAll('[name="selling_plan"]') || []);

      const checked = controls.find((control) => control.matches('input[type="radio"]:checked, input[type="checkbox"]:checked'));

      const select = controls.find((control) => control.tagName === 'SELECT');

      const hidden = controls.find((control) => control.matches('input[type="hidden"]'));

      return String(checked?.value || select?.value || hidden?.value || '').trim();

    };



    const updatePurchaseState = () => {

      const variantControl = form.querySelector('[name="id"]');

      const variantId = String(variantControl?.value || '');

      const variantRecord = purchaseState.variants?.[variantId] || {};

      const variantAvailable = Boolean(variantRecord.available);

      const planId = selectedSellingPlan();

      const validPlans = Array.isArray(preorderState?.variants?.[variantId])

        ? preorderState.variants[variantId].map(String)

        : [];

      const manufacturerInquiry = commerceState === 'manufacturer_inquiry';

      const nativeSellingPlanValid = validPlans.length === 0 || Boolean(planId && validPlans.includes(planId));

      const variantCommerce = preorderState?.variantCommerce?.[variantId] || {};

      const mixedVariantPreorder = Boolean(preorderState?.mixedVariantInventory && variantCommerce.preorderEligible);

      const productPreorder = Boolean(

        !preorderState?.mixedVariantInventory && commerceState === 'preorder' && preorderState?.baseReady && nativeSellingPlanValid

      );

      const preorderActive = Boolean(

        !manufacturerInquiry && (mixedVariantPreorder || productPreorder)

      );

      const purchaseEnabled = manufacturerInquiry ? false : preorderActive || variantAvailable;



      const price = info?.querySelector('[data-product-price]');

      const priceHtml = purchaseState.variants?.[variantId]?.priceHtml;

      const renderedPriceHtml = isGiftCard && !giftCardVariantInteracted

        ? purchaseState.initialPriceHtml

        : priceHtml;

      if (price && renderedPriceHtml) {

        const normalizedPrice = document.createElement('template');

        normalizedPrice.innerHTML = renderedPriceHtml;

        if (price.innerHTML.trim() !== normalizedPrice.innerHTML.trim()) price.innerHTML = renderedPriceHtml;

      }

      form.dataset.preorderActive = String(preorderActive);

      form.classList.toggle('product__form--unavailable', !purchaseEnabled);

      if (info) info.dataset.preorderActive = String(preorderActive);

      if (panel) panel.hidden = !preorderActive;

      if (purchaseControls) purchaseControls.hidden = !purchaseEnabled;

      if (unavailable) unavailable.hidden = purchaseEnabled;

      if (availabilityNotice) {
        const managedStockIsZero = Boolean(variantRecord.inventoryManaged) && Number(variantRecord.inventoryQuantity) <= 0;
        const unavailableNonPreorder = !variantAvailable && !preorderActive && !manufacturerInquiry && !isGiftCard;
        const availabilityNoticeVisible = managedStockIsZero && unavailableNonPreorder;
        const availabilityVariantChanged = previousAvailabilityVariantId !== null && previousAvailabilityVariantId !== variantId;
        availabilityNotice.hidden = !availabilityNoticeVisible;
        if (unavailable && availabilityNoticeVisible) unavailable.hidden = true;
        if (!availabilityNoticeVisible || availabilityVariantChanged) setAvailabilityPanel(false);
        previousAvailabilityVariantId = variantId;
        const variantField = availabilityNotice.querySelector('[data-availability-variant]');
        const skuField = availabilityNotice.querySelector('[data-availability-sku]');

        const nextVariantValue = String(variantRecord.title || '');

        const nextSkuValue = String(variantRecord.sku || '');

        if (variantField) {
          if (variantField.value !== nextVariantValue) variantField.value = nextVariantValue;
          if (variantField.getAttribute('value') !== nextVariantValue) variantField.setAttribute('value', nextVariantValue);
        }
        if (skuField) {
          if (skuField.value !== nextSkuValue) skuField.value = nextSkuValue;
          if (skuField.getAttribute('value') !== nextSkuValue) skuField.setAttribute('value', nextSkuValue);
        }
      }



      form.querySelectorAll('quantity-input button, quantity-input input').forEach((control) => {

        control.disabled = !purchaseEnabled;

      });



      if (submit) {

        const submitLabel = preorderActive ? submit.dataset.preorderLabel : submit.dataset.defaultLabel;

        submit.disabled = !purchaseEnabled;

        if (submit.textContent.trim() !== submitLabel) submit.textContent = submitLabel;

      }

    };



    info?.addEventListener('change', (event) => {

      if (event.target.matches('[name="id"]')) giftCardVariantInteracted = true;

      if (event.target.matches('[name="id"], [name="selling_plan"]')) updatePurchaseState();

    });

    info?.addEventListener('input', (event) => {

      if (event.target.matches('[name="selling_plan"]')) updatePurchaseState();

    });



    form.addEventListener('click', (event) => {

      const button = event.target.closest('quantity-input [data-qty]');

      if (!button || button.disabled) return;



      const quantity = button.closest('quantity-input');

      const input = quantity?.querySelector('input[name="quantity"]');

      if (!input || input.disabled) return;



      event.preventDefault();

      const current = Number(input.value || input.min || 1);

      const delta = Number(button.dataset.qty || 0);

      const minimum = Number(input.min || 1);

      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;

      const next = Math.min(maximum, Math.max(minimum, current + delta));



      if (next === current) return;

      input.value = String(next);

      input.dispatchEvent(new Event('change', { bubbles: true }));

    });



    const observer = new MutationObserver((mutations) => {

      if (mutations.some((mutation) => mutation.type === 'childList' || mutation.attributeName === 'value' || mutation.attributeName === 'checked')) {

        updatePurchaseState();

      }

    });

    observer.observe(info || form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });

    updatePurchaseState();

  };



  const descriptionSentences = (text) => (

    text.match(/[^.!?…]+(?:[.!?…]+["'»“”’)]*|$)/g) || [text]

  ).map((sentence) => sentence.trim()).filter(Boolean);



  const buildDescriptionSummary = (full, summary, maximumLines) => {

    const text = full.textContent.replace(/\s+/g, ' ').trim();

    if (!text || !full.clientWidth) return '';



    const styles = window.getComputedStyle(full);

    const lineHeight = Number.parseFloat(styles.lineHeight);

    if (!Number.isFinite(lineHeight)) return '';



    const maximumHeight = lineHeight * maximumLines + 1;

    if (full.scrollHeight <= maximumHeight) return '';



    const probe = document.createElement('div');

    probe.className = 'product__desc product__desc--probe';

    probe.style.width = `${full.clientWidth}px`;

    document.body.appendChild(probe);



    let accepted = '';

    for (const sentence of descriptionSentences(text)) {

      const candidate = accepted ? `${accepted} ${sentence}` : sentence;

      probe.textContent = candidate;

      if (probe.scrollHeight > maximumHeight && accepted) break;

      accepted = candidate;

      if (probe.scrollHeight > maximumHeight) break;

    }



    probe.remove();

    return accepted && accepted.length < text.length ? accepted : '';

  };



  const initializeProductDescription = (description) => {

    if (description.dataset.descriptionReady === 'true') return;



    const full = description.querySelector('[data-product-description-full]');

    const summary = description.querySelector('[data-product-description-summary]');

    const toggle = description.querySelector('[data-product-description-toggle]');

    const label = description.querySelector('[data-product-description-toggle-label]');

    if (!full || !summary || !toggle || !label) return;



    const summaryText = buildDescriptionSummary(full, summary, 6);

    description.dataset.descriptionReady = 'true';

    if (!summaryText) return;



    summary.textContent = summaryText;

    summary.hidden = false;

    full.hidden = true;

    toggle.hidden = false;



    toggle.addEventListener('click', () => {

      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!expanded));

      summary.hidden = !expanded;

      full.hidden = expanded;

      label.textContent = expanded ? toggle.dataset.readMore : toggle.dataset.readLess;

    });

  };



  const productDetailAliases = {

    farbe: 'color',

    oberflache: 'finish',

    oberfläche: 'finish',

    masse: 'dimensions',

    maße: 'dimensions',

    format: 'dimensions',

    gewicht: 'weight',

    fassungsvermogen: 'capacity',

    fassungsvermögen: 'capacity',

    setumfang: 'set_size',

    sprache: 'language',

    seiten: 'pages',

    bindung: 'binding',

    leistung: 'power',

    akku: 'battery',

    laufzeit: 'runtime',

    ladezeit: 'charge_time',

    schutzart: 'ingress_protection',

    kompatibilitat: 'compatibility',

    kompatibilität: 'compatibility',

    herstellungsland: 'country_of_manufacture',

    produktkennung: 'product_identifier',

  };



  const normalizeProductDetailKey = (value) => {

    const key = String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

    return productDetailAliases[key] || key;

  };



  const productDetailRow = (detail, labels) => {
    if (!detail || typeof detail !== 'object') return null;

    const key = normalizeProductDetailKey(detail.key || detail.label);

    const label = labels?.[key];

    const value = String(detail.value ?? '').trim();

    if (!label || !value) return null;



    const row = document.createElement('div');

    row.className = 'product__detail-row';

    const term = document.createElement('span');

    const description = document.createElement('p');

    term.textContent = label;

    description.textContent = value;

    row.append(term, description);

    return row;
  };

  const productContentTextList = (value) => (
    Array.isArray(value) ? value.map((item) => String(item ?? '').trim()).filter(Boolean) : []
  );

  const replaceProductContentList = (list, items) => {
    if (!list) return;
    list.replaceChildren(...items.map((item) => {
      const listItem = document.createElement('li');
      listItem.textContent = item;
      return listItem;
    }));
    list.hidden = items.length === 0;
  };

  const productContentMultilineList = (value) => (
    String(value ?? '').split(/\r?\n/).map((item) => item.trim()).filter(Boolean)
  );

  const replaceVariantStory = (content, variantId) => {
    const productInfo = content.closest('.product__info');
    const story = productInfo?.querySelector('[data-pdp-variant-story]');
    if (!story) return;

    const template = Array.from(productInfo.querySelectorAll('[data-pdp-variant-story-template]'))
      .find((candidate) => candidate.dataset.variantId === String(variantId));
    const hasStory = Boolean(template?.content?.children.length);
    story.replaceChildren(...(hasStory ? Array.from(template.content.cloneNode(true).childNodes) : []));
    story.hidden = !hasStory;
  };

  const replaceVariantSafety = (content, state, selected) => {
    if (!state.productUsesVariantSafety) return;

    const safetyAccordion = content.querySelector('[data-product-content-safety]');
    if (!safetyAccordion) return;

    const warningItems = productContentMultilineList(selected.warnings);
    const uniqueWarnings = [...new Set(warningItems.map(normalizedProductContentText))];
    const safetyInformation = productContentTextList(selected.variantSafetyInformation)
      .filter((item) => !uniqueWarnings.includes(normalizedProductContentText(item)));

    const warningGroup = safetyAccordion.querySelector('[data-product-content-safety-warnings]');
    const warningList = safetyAccordion.querySelector('[data-product-content-safety-warnings-list]');
    const safetyGroup = safetyAccordion.querySelector('[data-product-content-safety-information]');
    const safetyList = safetyAccordion.querySelector('[data-product-content-safety-information-list]');
    const safetyNote = safetyAccordion.querySelector('[data-product-content-safety-note]');
    const safetyNoteValue = safetyAccordion.querySelector('[data-product-content-safety-note-value]');

    replaceProductContentList(warningList, warningItems);
    replaceProductContentList(safetyList, safetyInformation);
    if (warningGroup) warningGroup.hidden = warningItems.length === 0;
    if (safetyGroup) safetyGroup.hidden = safetyInformation.length === 0;
    if (safetyNoteValue) safetyNoteValue.replaceChildren();
    if (safetyNote) safetyNote.hidden = true;

    safetyAccordion.hidden = warningItems.length === 0 && safetyInformation.length === 0;
    if (safetyAccordion.hidden) safetyAccordion.open = false;
    syncProductContentAccordion(safetyAccordion);
  };

  const normalizedProductContentText = (value) => String(value ?? '').trim().toLocaleLowerCase();


  const syncProductContentAccordion = (accordion) => {
    const summary = accordion.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(accordion.open));
  };

  const closeSiblingProductContentAccordions = (content, currentAccordion) => {
    if (!currentAccordion.open) return;
    content.querySelectorAll('details.product__accordion[open]').forEach((accordion) => {
      if (accordion !== currentAccordion) accordion.open = false;
    });
  };


  const updateProductContent = (content, variantId, updateUrl) => {

    const state = parseJsonNode(content.querySelector('[data-product-content-state]'));

    if (!state) return;



    const selected = state.variants?.[String(variantId)] || {};

    replaceVariantStory(content, variantId);
    replaceVariantSafety(content, state, selected);
    const variantDetails = Array.isArray(selected.details) ? selected.details : [];

    const variantDetailContainer = content.querySelector('[data-product-content-variant-details]');

    if (variantDetailContainer) {

      const rows = variantDetails.map((detail) => productDetailRow(detail, state.labels)).filter(Boolean);

      variantDetailContainer.replaceChildren(...rows);

      variantDetailContainer.hidden = rows.length === 0;

    }



    const productIncluded = Array.isArray(state.productIncluded) ? state.productIncluded : [];

    const variantIncluded = Array.isArray(selected.included) ? selected.included : [];

    const included = variantIncluded.length > 0 ? variantIncluded : productIncluded;

    const includedGroup = content.querySelector('[data-product-content-included]');

    const includedList = content.querySelector('[data-product-content-included-list]');

    if (includedGroup && includedList) {

      includedList.replaceChildren(...included.map((item) => {

        const listItem = document.createElement('li');

        listItem.textContent = String(item);

        return listItem;

      }));

      includedGroup.hidden = included.length === 0;

    }



    const detailsStage = content.querySelector('[data-product-content-accordion="details"]');

    if (detailsStage) {

      const staticRows = content.querySelectorAll('[data-product-content-product-details] .product__detail-row').length;

      const variantRows = variantDetailContainer?.querySelectorAll('.product__detail-row').length || 0;

      detailsStage.hidden = staticRows + variantRows === 0;

    }



    const deliveryAccordion = content.querySelector('[data-product-content-accordion="delivery"]');
    if (deliveryAccordion) {

      const hasExclusions = Boolean(content.querySelector('[data-product-content-excluded]'));

      deliveryAccordion.hidden = included.length === 0 && !hasExclusions;

      if (deliveryAccordion.hidden) deliveryAccordion.open = false;

      syncProductContentAccordion(deliveryAccordion);
    }

    const productCare = productContentTextList(state.productCare);
    const variantCare = productContentTextList(selected.care);
    const care = variantCare.length > 0 ? variantCare : productCare;
    const careList = content.querySelector('[data-product-content-care-list]');
    replaceProductContentList(careList, care);

    const careNote = content.querySelector('[data-product-content-care-note]');
    const careNoteValue = String(state.productCareNote ?? '').trim();
    const careSignatures = new Set(care.map(normalizedProductContentText));
    const careNoteVisible = Boolean(careNoteValue) && !careSignatures.has(normalizedProductContentText(careNoteValue));
    if (careNote) {
      careNote.textContent = careNoteValue;
      careNote.hidden = !careNoteVisible;
    }

    const careManufacturer = content.querySelector('[data-product-content-care-manufacturer]');
    if (careManufacturer) careManufacturer.hidden = care.length === 0 && !careNoteVisible;

    if (careNoteVisible) careSignatures.add(normalizedProductContentText(careNoteValue));
    const variantEditorialCare = String(selected.editorialCare ?? '').trim();
    const productEditorialCare = String(state.productEditorialCare ?? '').trim();
    const editorialCare = variantEditorialCare || productEditorialCare;
    const editorialCareVisible = Boolean(editorialCare) && !careSignatures.has(normalizedProductContentText(editorialCare));
    const editorialCareSection = content.querySelector('[data-product-content-care-editorial]');
    const editorialCareText = content.querySelector('[data-product-content-care-editorial-text]');
    if (editorialCareText) editorialCareText.textContent = editorialCare;
    if (editorialCareSection) editorialCareSection.hidden = !editorialCareVisible;

    const usageVisible = Boolean(content.querySelector('[data-product-content-usage]'));
    const careAccordion = content.querySelector('[data-product-content-accordion="care"]');
    if (careAccordion) {
      careAccordion.hidden = !usageVisible && care.length === 0 && !careNoteVisible && !editorialCareVisible;
      if (careAccordion.hidden) careAccordion.open = false;
      syncProductContentAccordion(careAccordion);
    }

    const productOrigin = productContentTextList(state.productOrigin);
    const variantOrigin = productContentTextList(selected.origin);
    const origin = variantOrigin.length > 0 ? variantOrigin : productOrigin;
    const originContainer = content.querySelector('[data-product-content-origin-variant]');
    if (originContainer) {
      const originRows = origin.map((value) => productDetailRow({ key: 'origin', value }, state.labels)).filter(Boolean);
      originContainer.replaceChildren(...originRows);
    }

    const originAccordion = content.querySelector('[data-product-content-accordion="origin"]');
    if (originAccordion) {
      const staticOriginRows = originAccordion.querySelectorAll('[data-product-content-origin-static] .product__detail-row').length;
      originAccordion.hidden = origin.length === 0 && staticOriginRows === 0;
      if (originAccordion.hidden) originAccordion.open = false;
      syncProductContentAccordion(originAccordion);
    }

    const variantProductIdentifier = String(selected.productIdentifier ?? '').trim();
    const productIdentifier = variantProductIdentifier || String(state.productIdentifier ?? '').trim();
    const productIdentifierRow = content.querySelector('[data-product-content-product-identifier]');
    const productIdentifierValue = content.querySelector('[data-product-content-product-identifier-value]');
    if (productIdentifierValue) productIdentifierValue.textContent = productIdentifier;
    if (productIdentifierRow) productIdentifierRow.hidden = !productIdentifier;

    const sku = String(selected.sku ?? '').trim();
    const skuRow = content.querySelector('[data-product-content-sku]');
    const skuValue = content.querySelector('[data-product-content-sku-value]');
    if (skuValue) skuValue.textContent = sku;
    if (skuRow) skuRow.hidden = !sku;

    const manufacturerAccordion = content.querySelector('[data-product-content-accordion="manufacturer-responsibility"]');
    if (manufacturerAccordion) {
      const staticManufacturerRows = manufacturerAccordion.querySelectorAll('.product__detail-row:not([data-product-content-product-identifier])').length;
      manufacturerAccordion.hidden = !productIdentifier && staticManufacturerRows === 0;
      if (manufacturerAccordion.hidden) manufacturerAccordion.open = false;
      syncProductContentAccordion(manufacturerAccordion);
    }

    if (updateUrl && variantId && window.history?.replaceState && !window.Shopify?.designMode) {
      const url = new URL(window.location.href);

      url.searchParams.set('variant', String(variantId));

      window.history.replaceState({}, '', url);

    }

  };



  const initializeProductContent = (content) => {
    if (content.dataset.productContentReady === 'true') return;
    const state = parseJsonNode(content.querySelector('[data-product-content-state]'));

    content.dataset.productContentReady = 'true';
    content.querySelectorAll('details.product__accordion').forEach((accordion) => {
      accordion.open = false;
      syncProductContentAccordion(accordion);
      accordion.addEventListener('toggle', () => {
        closeSiblingProductContentAccordions(content, accordion);
        syncProductContentAccordion(accordion);
      });
    });

    if (!state) return;

    const page = content.closest('[data-product-page]');
    const info = content.closest('[data-product-info]') || page?.querySelector('[data-product-info]');

    const variantControl = info?.querySelector('form[data-product-form] [name="id"]');

    const selectedId = () => String(variantControl?.value || '');

    variantControl?.addEventListener('change', () => updateProductContent(content, selectedId(), true));

    updateProductContent(content, selectedId(), false);

  };



  const initializeProductExperience = (root = document) => {

    const forms = root.matches?.('form[data-product-form]')

      ? [root]

      : Array.from(root.querySelectorAll?.('form[data-product-form]') || []);

    forms.forEach(initializeProductForm);



    const descriptions = root.matches?.('[data-product-description]')

      ? [root]

      : Array.from(root.querySelectorAll?.('[data-product-description]') || []);

    descriptions.forEach(initializeProductDescription);



    const productContents = root.matches?.('[data-product-content]')

      ? [root]

      : Array.from(root.querySelectorAll?.('[data-product-content]') || []);

    productContents.forEach(initializeProductContent);

  };

  const optionLabelOverrides = new Map([

    ['MIT VERPACKUNG', 'Mit Verpackung'],

  ]);



  const normalizeOptionLabel = (value) => {

    const text = String(value || '').trim();

    return optionLabelOverrides.get(text) || text;

  };



  const initializeOptionLabels = (root = document) => {

    const selects = root.matches?.('[data-normalize-option-labels]')

      ? [root]

      : Array.from(root.querySelectorAll?.('[data-normalize-option-labels]') || []);



    selects.forEach((select) => {

      if (select.dataset.optionLabelsReady === 'true') return;

      select.dataset.optionLabelsReady = 'true';

      Array.from(select.options).forEach((option) => {

        option.textContent = normalizeOptionLabel(option.textContent);

      });

    });

  };



  const revealObserver = (

    'IntersectionObserver' in window

    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches

  ) ? new IntersectionObserver((entries, observer) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');

        observer.unobserve(entry.target);

      });

    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;



  const initializeReveals = (root = document) => {

    const targets = root.matches?.('[data-reveal]')

      ? [root]

      : Array.from(root.querySelectorAll?.('[data-reveal]') || []);



    targets.forEach((target) => {

      if (target.dataset.revealReady === 'true') return;

      target.dataset.revealReady = 'true';

      const homepageWithoutV3Reveal = document.body.classList.contains('template-index')
        && window.getComputedStyle(document.body).getPropertyValue('--v3-home-reveal').trim() !== '1';

      if (homepageWithoutV3Reveal) {

        target.classList.add('is-visible');

        return;

      }

      if (revealObserver) {

        revealObserver.observe(target);

      } else {

        target.classList.add('is-visible');

      }

    });

  };


  document.documentElement.classList.add('reveal-ready');





  initializeProductExperience();

  initializeOptionLabels();

  initializeReveals();



  document.addEventListener('shopify:section:load', (event) => {

    initializeProductExperience(event.target);

    initializeOptionLabels(event.target);

    initializeReveals(event.target);



  });

})();

